export const projectActionType = {
  ALL_PROJECT_REQUEST: "ALL_PROJECT_REQUEST",
  ALL_PROJECT_FAIL: "ALL_PROJECT_FAIL",
  ALL_PROJECT_SUCCESS: "ALL_PROJECT_SUCCESS",

  CREATE_PROJECT_REQUEST: "CREATE_PROJECT_REQUEST",
  CREATE_PROJECT_FAIL: "CREATE_PROJECT_FAIL",
  CREATE_PROJECT_SUCCESS: "CREATE_PROJECT_SUCCESS",

  DELETE_PROJECT_REQUEST: "DELETE_PROJECT_REQUEST",
  DELETE_PROJECT_FAIL: "DELETE_PROJECT_FAIL",
  DELETE_PROJECT_SUCCESS: "DELETE_PROJECT_SUCCESS",

  UPDATE_PROJECT_REQUEST: "UPDATE_PROJECT_REQUEST",
  UPDATE_PROJECT_FAIL: "UPDATE_PROJECT_FAIL",
  UPDATE_PROJECT_SUCCESS: "UPDATE_PROJECT_SUCCESS",
};
